import './Navbar.css'
import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {


    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);
    const [color, setColor] = useState(false)
    const changeColor = () => {
        if (window.scrollY >= 100) {
            setColor(true);
        } else {
            setColor(false)
        }
    };

    window.addEventListener("scroll", changeColor);

    return (
        <div className={color ? "header header-bg" : "header"}>
            <h1>Portfolio</h1>
            <ul className={click ? "nav_menu active" :
                "nav_menu"}>
                <li>
                    <Link to="/"> Home </Link>
                </li>
                <li>
                    <Link to="/about"> About </Link>
                </li>
                <li>
                    <Link to="/Education"> Education </Link>
                </li>
                <li>
                    <Link to="/Work"> Work </Link>
                </li>
                <li>
                    <Link to="/Project"> Project </Link>
                </li>
                <li>
                    <Link to="/GitHubRepositories"> GitHub </Link>
                </li>
                <li>
                    <Link to="/contact"> Contact </Link>
                </li>
            </ul>
            <div className='hamburger' onClick={handleClick}>
                {click ? (
                    <FaTimes size={20} style={{ color: " #2f3c45" }} />
                ) : (
                    <FaBars size={20} style={{ color: "white" }} />
                )}
            </div>

        </div>
    )
}

export default Navbar